var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('NewMonthList',{attrs:{"contents":_vm.contents}}),(_vm.month)?_c('v-container',{attrs:{"fluid":""}},[_c('v-col',[_c('NewMonthTitle')],1)],1):_c('v-container',{attrs:{"fluid":""}},[_c('NoContentsMessage')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }